module.exports = __webpack_public_path__ + "static/media/0026_IMG_LES_ENSEIGNES_LE_BOUCHER_LETTRE_A_LETTRE.49942d63.webp";